export default defineNuxtPlugin({
  async setup() {
    const { $auth, $api } = useNuxtApp();
    const rating = reactive({
      ratingChip: false,
      async getUserWallet(articleId: string): Promise<unknown> {
        try {
          let user = $auth.user;
          if (user?.roles[0] === 'user') {
            const userWallet = await $api.endPoints.getUserWallet(articleId);
            return { userWallet };
          } else {
            // TODO hanlde error
            // console.info('not infoged in user !!');
          }
        } catch (error) {
          // TODO handle error
          // console.info(error);
        }
      },
      async getUserRating(articleId: string): Promise<unknown> {
        try {
          let user = $auth.user;
          if (user?.roles[0] === 'user') {
            const userRating = await $api.endPoints.getUserRating(articleId);
            return { userRating };
          } else {
            // TODO handle error
            // console.info('not infoged in user !!');
          }
        } catch (error) {
          // TODO handle error
          // console.info(error);
        }
      },
      async putUserRating(
        articleId: string,
        score: string,
        deviceId: string,
        contentType?: string,
      ): Promise<unknown> {
        try {
          let user = $auth.user;
          if (user?.roles[0] === 'user') {
            const resp = await $api.endPoints.putUserRating(
              articleId,
              score,
              deviceId,
              contentType,
            );
            return { resp };
          } else {
            // TODO handle Error
            // console.info('not infoged in user !!');
          }
        } catch (error) {
          // TODO hanlde Error
          // console.info(error);
        }
      },
      toggleRatingChip() {
        this.ratingChip = !this.ratingChip;
      },
    });
    return {
      provide: {
        rating,
      },
    };
  },
});
